<script>
import MeetingRoom from "~/components/MeetingRoomCard.vue";

const SPACES_QUERY = gql`
  query SpacesQuery {
    pages(first: 50) {
      edges {
        node {
          id
          slug
          title
          language {
            slug
          }
          spacesconfig {
            heroimgh {
              mediaItemUrl
            }
          }
        }
      }
    }
  }
`;

export default {
  name: "MeetingRooms",
  components: { MeetingRoom },
  props: {
    setCursor: {
      required: true,
      type: Function,
    },
  },
  async setup() {
    const meetingRooms = ref([
      {
        name: "spaces.mosaic.otakar.title",
        key: "otakar",
        description: "spaces.mosaic.otakar",
        capacity: "30",
        space: 41,
        price: "1200",
        imgSrc: "/img/Rectangle364.png",
      },
      {
        name: "spaces.mosaic.salvator.title",
        key: "salvator",
        description: "spaces.mosaic.salvator",
        capacity: "20",
        space: 28,
        price: "900",
        imgSrc: "/img/Rectangle364(2).png",
      },
      {
        name: "spaces.mosaic.stenc.title",
        key: "stenc",
        description: "spaces.mosaic.stenc",
        capacity: "10",
        space: 28,
        price: "2500",
        imgSrc: "/img/Rectangle364(1).png",
      },
      {
        name: "spaces.mosaic.maxmilian.title",
        key: "maximilian",
        description: "spaces.mosaic.maxmilian",
        capacity: "6",
        space: 13,
        price: "600",
        imgSrc: "/img/Rectangle364(3).png",
      },
      {
        name: "spaces.mosaic.viola.title",
        key: "viola",
        description: "spaces.mosaic.viola",
        capacity: "4",
        space: 13,
        price: "300",
        imgSrc: "/img/Rectangle364(4).png",
      },
      {
        name: "spaces.mosaic.amelie.title",
        key: "amelie",
        description: "spaces.mosaic.amelie",
        capacity: "6",
        space: 17,
        price: "300",
        imgSrc: "/img/amelie/IMG_7471-hero.jpg",
      },
      {
        name: "spaces.mosaic.kavarna.title",
        key: "kavarna",
        description: "spaces.mosaic.kavarna",
        capacity: "24",
        space: 43,
        price: "300",
        imgSrc: "/img/amelie/IMG_7471-hero.jpg",
      },
      {
        name: "spaces.mosaic.terasa.title",
        key: "terasa",
        description: "spaces.mosaic.terasa",
        capacity: "16",
        space: 29,
        price: "3000",
        imgSrc: "/img/Rectangle364(5).png",
      },
      {
        name: "spaces.mosaic.atrium.title",
        key: "atrium",
        description: "spaces.mosaic.atrium",
        capacity: "130",
        space: 73,
        price: "5000",
        imgSrc: "/img/Rectangle364(5).png",
      },
      
      // {
      //   name: "spaces.mosaic.manes.title",
      //   key: "manes",
      //   description: "spaces.mosaic.manes",
      //   capacity: "8",
      //   space: 28,
      //   price: "1200",
      //   imgSrc: "/img/manes/manes1_cover2.jpg",
      // },
    ]);

    const { locale } = useI18n();
    const apolloClient = useApolloClient().client;

    // Fetch the GraphQL data synchronously
    const { data } = await apolloClient.query({ query: SPACES_QUERY, fetchPolicy: "no-cache" });

    const pages = data.pages?.edges ?? [];

    const heroMap = pages.reduce((acc, edge) => {
      const node = edge.node;
      if (
        node?.spacesconfig?.heroimgh?.mediaItemUrl &&
        node?.language?.slug === locale.value.toLowerCase()
      ) {
        acc[node.slug] = node.spacesconfig.heroimgh.mediaItemUrl;
      }
      return acc;
    }, {});

    meetingRooms.value = meetingRooms.value.map((room) => ({
      ...room,
      imgSrc: heroMap[room.key] || room.imgSrc,
    }));

    return { meetingRooms };
  }
};
</script>

<template>
  <div
    class="flex justify-center lg:cursor-none"
    @mouseenter="
      setCursor(null, null, {
        'font-size': '14px',
        background: '#FFC800',
        width: '25px',
        height: '25px',
      })
    "
  >
    <div class="grid lg:p-12 meeting-rooms-container max-w-7xl">
      <MeetingRoomCard
        v-for="(room, index) in meetingRooms"
        :key="index"
        :room="room"
        :set-cursor="setCursor"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.meeting-rooms-container {
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  justify-items: center;
  gap: 20px;
  row-gap: 32px;

  @media screen and (max-width: 1246px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0;
    row-gap: 32px;
  }
}
</style>
